<template>
  <div class="w-100" v-if="content && page">
    <v-container>
      <!-- <v-row class="justify-center mb-3">
        <v-col
          :cols="$vuetify.breakpoint.smAndDown ? 12 : 9"
          class="d-flex justify-space-around flex-wrap"
        >
          <v-btn
            class="mt-4"
            rounded
            color="primary"
            dark
            v-for="(link, index) in links"
            :key="index"
            @click="$router.push(link.route)"
          >
            {{ link.title }}
          </v-btn>
        </v-col>
      </v-row> -->
      <v-row class="justify-center">
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 9">
          <PostBlock :html="content.data"></PostBlock>
        </v-col>
      </v-row>

      <v-row class="justify-center">
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 9" class="mb-5">
          <div class="text--secondary" v-if="page.updatedAt">
            Sidan uppdaterad {{ prettyDate(page.updatedAt) }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Setup from '@/mixins/Setup.js'
import Misc from '@/mixins/Misc.js'
import DataLayer from '@/store/PagesDataLayer'
import PostBlock from '@/components/PostBlock'
import { format, parseISO } from 'date-fns'
export default {
  name: 'PageChild',
  props: { nameUrl: String },
  mixins: [Setup, Misc],
  components: {
    PostBlock
  },
  data() {
    return {
      page: null,
      content: null,
      links: [
        { title: 'Quiz', route: { name: 'quiz' } },
        { title: 'Redaktionen', route: { name: 'redaktion' } },
        {
          title: 'Medverkande experter',
          route: { name: 'medverkande-experter' }
        },
        { title: 'Engagera dig', route: { name: 'engagera-dig' } }
      ]
    }
  },
  watch: {
    $route: 'setup'
  },

  methods: {
    prettyDate(val) {
      try {
        return format(parseISO(val), 'yyyy-MM-dd')
      } catch (e) {
        return val
      }
    },
    setup() {
      const pageId = this.$route.meta.pageId
      DataLayer.GetPageById(pageId).then(res => {
        this.page = res.data[0]
      })
      DataLayer.GetItemsInPageById(pageId).then(res => {
        this.content = res.data[0]
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
